import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/esm/typeof";
var _excluded = ["size", "color", "spin", "className"];
import React, { useRef } from "react";
import cns from "classnames";
import { ConfigContext } from "../ConfigProvider";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getUuid() {
  if ((typeof crypto === "undefined" ? "undefined" : _typeof(crypto)) === "object") {
    if (typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
    if (typeof crypto.getRandomValues === "function" && typeof Uint8Array === "function") {
      var callback = function callback(c) {
        var num = Number(c);
        return (num ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> num / 4).toString(16);
      };
      // @ts-ignore
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, callback);
    }
  }
  var timestamp = new Date().getTime();
  var perforNow = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
  return "dwdddqwe-xxxx-4xxx-yxxx-dwerwecwcwed".replace(/[xy]/g, function (c) {
    var random = Math.random() * 16;
    if (timestamp > 0) {
      random = (timestamp + random) % 16 | 0;
      timestamp = Math.floor(timestamp / 16);
    } else {
      random = (perforNow + random) % 16 | 0;
      perforNow = Math.floor(perforNow / 16);
    }
    return (c === "x" ? random : random & 0x3 | 0x8).toString(16);
  });
}
export function IconLoading(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    spin = _ref.spin,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls();
  var ids = useRef(function () {
    var id = getUuid();
    return [id, id + "x"];
  }());
  return (
    /*#__PURE__*/
    // @ts-ignore
    _jsx("span", {
      className: cns("piicon piicon-loading", className, _defineProperty({}, "".concat(prefixCls, "icon-spin"), spin)),
      style: {
        // TODO: 后续需换到less中
        height: size,
        width: size
      },
      children: /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 200 200",
        fill: "none",
        style: {
          overflow: "visible"
        }
      }, props), {}, {
        children: [/*#__PURE__*/_jsxs("defs", {
          children: [/*#__PURE__*/_jsxs("linearGradient", {
            id: ids.current[0],
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0%",
              stopOpacity: "0",
              stopColor: "currentColor"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "100%",
              stopOpacity: "0.5",
              stopColor: "currentColor"
            })]
          }), /*#__PURE__*/_jsxs("linearGradient", {
            id: ids.current[1],
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0%",
              stopOpacity: "1",
              stopColor: "currentColor"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "100%",
              stopOpacity: "0.5",
              stopColor: "currentColor"
            })]
          })]
        }), /*#__PURE__*/_jsxs("g", {
          strokeWidth: "24",
          children: [/*#__PURE__*/_jsx("path", {
            stroke: "url(#".concat(ids.current[0], ")"),
            d: "M 4 100 A 96 96 0 0 1 196 100"
          }), /*#__PURE__*/_jsx("path", {
            stroke: "url(#".concat(ids.current[1], ")"),
            d: "M 196 100 A 96 96 0 0 1 4 100"
          }), /*#__PURE__*/_jsx("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M 4 100 A 96 96 0 0 1 4 98"
          })]
        })]
      }))
    })
  );
}